import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Monitoring from "./pages/Monitoring";
import Laporan from "./pages/Laporan";

function App() {
  return (
    <Router>
      {/* Navigasi menu */}
      <nav style={{ marginBottom: "20px", padding: "10px", background: "#f5f5f5" }}>
        <Link to="/" style={{ marginRight: "20px" }}>📍 Monitoring</Link>
        <Link to="/laporan">📊 Laporan</Link>
      </nav>

      {/* Routing ke halaman */}
      <Routes>
        <Route path="/" element={<Monitoring />} />
        <Route path="/laporan" element={<Laporan />} />
      </Routes>
    </Router>
  );
}

export default App;
